module.exports = __webpack_public_path__ + "img/54f75da.jpg";